export const TypeEntiteJuridique = [
  'Entreprise',
  'Etablissement',
  'Groupe',
] as const

export type TypeEntiteJuridique = typeof TypeEntiteJuridique[number]

export const TypeEntiteJuridiqueLibelle: {
  [key in TypeEntiteJuridique]: string
} = {
  Entreprise: 'Entreprise',
  Etablissement: 'Etablissement',
  Groupe: 'Groupe',
} as const
